import {
  MonitorSmartphone, LayoutDashboard, Presentation, FolderOpen, Video,
  ClipboardCheck, LineChart, BookMarked, CreditCard, BarChart3, MailCheck, BellRing,
} from "lucide-react";
import PageHero from "@/components/PageHero";
import Section from "@/components/Section";
import Reveal from "@/components/Reveal";

const CAPABILITIES = [
  { icon: MonitorSmartphone, label: "Learning Management Systems", text: "Centralised platforms to deliver, manage and track structured learning programmes." },
  { icon: LayoutDashboard, label: "Student Dashboards", text: "Personal learning spaces for schedules, resources, assessments and progress." },
  { icon: Presentation, label: "Teacher Dashboards", text: "Tools for educators to manage classes, curriculum delivery and learner feedback." },
  { icon: FolderOpen, label: "Digital Learning Resources", text: "Structured study material and practice content organised around the curriculum." },
  { icon: Video, label: "Live Online Classrooms", text: "Interactive, human-led live learning — not passive prerecorded content." },
  { icon: ClipboardCheck, label: "Assessments", text: "Regular evaluation designed to measure conceptual clarity and readiness." },
  { icon: LineChart, label: "Progress Tracking", text: "Visibility into learner development for students, parents and educators." },
  { icon: BookMarked, label: "Curriculum Management", text: "Structured curricula maintained and improved centrally across programmes." },
  { icon: CreditCard, label: "Digital Payments", text: "Simple, secure fee management and enrolment experiences." },
  { icon: BarChart3, label: "Analytics", text: "Data-informed decisions across learning outcomes and operations." },
  { icon: MailCheck, label: "Automated Communication", text: "Timely, relevant communication between institutions, educators and learners." },
  { icon: BellRing, label: "Learner Engagement Systems", text: "Mechanisms that keep learners motivated, consistent and supported." },
];

export default function Innovation() {
  return (
    <div data-testid="innovation-page">
      <PageHero
        eyebrow="Technology & Innovation"
        title="Technology that enables better learning."
        lede="RCS believes technology should strengthen human-led education instead of reducing education to prerecorded content."
      />

      <section className="py-24 lg:py-32" data-testid="innovation-capabilities">
        <div className="container-rcs">
          <Section
            eyebrow="Our Digital Learning Ecosystem"
            title="Capabilities we are building around."
            lede="Our digital learning ecosystem is being developed around capabilities including the following — each designed to serve educators and learners across our brands."
          />
          <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {CAPABILITIES.map((c, i) => (
              <Reveal key={c.label} delay={i * 0.05}>
                <div className="card-premium h-full" data-testid={`innovation-cap-${i}`}>
                  <c.icon className="h-6 w-6 text-gold-dark" aria-hidden />
                  <h3 className="mt-5 font-serif text-lg text-navy-900">{c.label}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{c.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-navy-950 py-24" data-testid="innovation-principle">
        <div className="container-rcs">
          <Section
            dark
            eyebrow="Our Principle"
            title="Human-led. Technology-enabled."
            lede="Across The Topper Academy and Indian School of Music, technology serves one purpose: making the relationship between educators and learners stronger, more structured and more accessible."
          />
        </div>
      </section>
    </div>
  );
}
